import React from "react";
import { Link } from "react-router-dom";

export default class ResetPasswordConfirmation extends React.Component {
    constructor(props) {
        super(props);
        this.dashboardUrl = window && window.serverData && window.serverData.data && window.serverData.data.linkToBSWHealth
            ? window.serverData.data.linkToBSWHealth
            : '/';
    }

    render() {    
        const { careGiverUrl, redirect } = this.props;
        return (
            <div className="reset-pw-success logged-out-success">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <div className="row">
                            <div className="col-12">
                                <div className="icon-list-check" />
                                <h2 className="step-heading success-heading">Thanks, your password was successfully changed!</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 text-center">
                                <div className="btn btn-primary" onClick={() => window.location.replace(redirect == "1" ? careGiverUrl : this.dashboardUrl)}>Continue to Sign In</div>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}